jQuery(document).on("page.ready", function () {
  $ = jQuery;

  if ($("main.blog-single.resource-single").length) {
    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

    /*****************************************************************
     * Set Custom classes for first and last sections even when there's a gap element
     *****************************************************************/
    $(".content-columns").each(function (index, el) {
      if (!$(el).prev().hasClass("content-columns")) {
        $(el).addClass("first");
      }

      if (!$(el).next().hasClass("content-columns")) {
        $(el).addClass("last");
      }
    });

    $(".content-columns").each(function (index, el) {
      if (!$(el).prev().hasClass("content-columns")) {
        $(el).addClass("first");
      }

      if (!$(el).next().hasClass("content-columns")) {
        $(el).addClass("last");
      }

      if (!$(el).next().hasClass("content-columns") && !$(el).prev().hasClass("content-columns")) {
        $(el).addClass("single-column");
      }
    });

    /*****************************************************************
      Projects
    ******************************************************************/
    var projectSlider = $(".projects .owl-carousel");
    projectSlider
      .owlCarousel({
        autoplay: false,
        loop: false,
        nav: true,
        navContainer: ".prop-controls",
        navElement: "div",
        navText: ["", ""],
        items: 1,
        margin: 0,
        slideBy: 1,
        rewind: true,
        rewindNav: true,
        rewindSpeed: 0,
        dots: false,
        autoHeight: true,
        lazyLoad: true,
        checkVisibility: false,
        responsive: {
          768: {
            items: 3,
          },
          950: {
            items: 3,
          },
          1200: {
            items: 3,
          },
        },
        onInitialized: function (e) {
          var totalCount = $(projectSlider).parents(".container").find(".slide-num-contain .nums-total");
          var currentCount = $(projectSlider).parents(".container").find(".slide-num-contain .nums-count");
          // totalCount.text("0" + e.item.count);

          var spacerItemsReducer = 2;
          if (isMobile) {
            spacerItemsReducer = 0;
          }

          totalCount.text("0" + (e.item.count - spacerItemsReducer));

          currentCount.text("0" + (e.item.index + 1));
        },
      })
      .on("changed.owl.carousel", function (e) {
        var currentCount = $(projectSlider).parents(".container").find(".slide-num-contain .nums-count");
        currentCount.text("0" + (e.item.index + 1));
      });

    $(window).on("resize", function () {
      $(".projects .owl-carousel .owl-stage-outer").width(innerWidth);
    });
  }
});
